var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"pulse-btn",class:[
    `pulse-btn--${_vm.severity}`,
    {
      'pulse-btn--outlined': _vm.outlined,
      'pulse-btn--text': _vm.text,
      'pulse-btn--rounded': _vm.rounded,
      'pulse-btn--small': _vm.small,
      'pulse-btn--block': _vm.block,
      'pulse-btn--icon-only': !_vm.label && !_vm.$slots.default,
    },
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading}},_vm.$listeners),[(_vm.loading)?_c('i',{staticClass:"pi pi-spinner pi-spin"}):(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.label || _vm.$slots.default)?_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }